import { Component } from '@angular/core';

import { FieldBaseComponent } from '@shared/components/forms/components/field-base';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-form-checkbox-list',
  styleUrls: ['form-checkbox-list.component.scss'],
  templateUrl: 'form-checkbox-list.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class FormCheckboxListComponent extends FieldBaseComponent {
  public get controls() {
    return this.config ? (this.formGroup?.controls[this.config.name] as any)?.controls : undefined;
  }

  public get validation() {
    return this.controls.find((valid: Record<string, boolean>) => valid.value) ? true : false;
  }
}
